import { motion } from "framer-motion";
import { Package, Truck, Wrench, ShieldCheck } from "lucide-react";

const PACKING_IMAGE = "https://static.prod-images.emergentagent.com/jobs/471e7bc7-0506-440b-a690-5c8807ef2677/images/dcd3874d038e314f2a03e34c43a4ba926eef741c18551be30b44daa0c151ac44.jpeg";

const steps = [
  {
    n: "01",
    Icon: Package,
    title: "Online beauftragen",
    text: "Wähle dein iPhone-Modell und die gewünschte Reparatur. Du siehst sofort den Festpreis inklusive Versand – ganz ohne Termin.",
  },
  {
    n: "02",
    Icon: Truck,
    title: "Gerät einsenden",
    text: "Nutze dein Versandetikett (PDF) und schicke dein iPhone sicher verpackt an uns. Deutschlandweit, unkompliziert und nachverfolgbar.",
  },
  {
    n: "03",
    Icon: Wrench,
    title: "Wir reparieren",
    text: "Display oder Akku werden mit Premium-Ersatzteilen getauscht und sorgfältig geprüft. Meist schon einen Werktag nach Eingang fertig.",
  },
  {
    n: "04",
    Icon: ShieldCheck,
    title: "Versichert zurück",
    text: "Dein repariertes iPhone geht versichert zurück zu dir nach Hause – bei Original-OLED-Displays inklusive 6 Monaten Garantie.",
  },
];

function Step({ s, i }) {
  return (
    <motion.div
      data-testid={`chapter-${s.n}`}
      initial={{ opacity: 0, x: 24 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
      className="relative flex items-start gap-5"
    >
      <div className="relative z-10 shrink-0 w-14 h-14 rounded-2xl bg-[#0a0a0a] border border-emerald-500/30 flex items-center justify-center text-emerald-400">
        <s.Icon size={22} />
      </div>
      <div className="pt-1.5">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-emerald-400 mb-1.5">
          Schritt {s.n}
        </p>
        <h3 className="font-display text-xl lg:text-2xl text-white leading-tight">{s.title}</h3>
        <p className="text-sm text-[#999] leading-relaxed mt-2 max-w-sm">{s.text}</p>
      </div>
    </motion.div>
  );
}

export default function Manifesto() {
  return (
    <section id="ablauf" data-testid="manifesto" className="relative z-10 bg-[#050505] py-24 lg:py-36 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-start">
          {/* Left: packing photo */}
          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="relative rounded-[2rem] overflow-hidden border border-white/10 lg:sticky lg:top-28"
          >
            <img
              src={PACKING_IMAGE}
              alt="Ein iPhone wird sicher mit Luftpolsterfolie für den Versand verpackt"
              className="w-full h-[420px] lg:h-[600px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/60 via-transparent to-transparent" />
          </motion.div>

          {/* Right: steps */}
          <div>
            <div className="flex items-center gap-3 mb-5 font-mono text-xs uppercase tracking-[0.25em] text-emerald-400">
              <span className="w-8 h-px bg-emerald-400/60" />
              In 4 Schritten erledigt
            </div>
            <h1 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              So einfach geht's.
            </h1>
            <p className="text-[#999] leading-relaxed mt-5 max-w-md">
              Vom Einsenden bis zur Rückgabe – wir kümmern uns um alles.
            </p>

            <div className="relative mt-14">
              <div className="absolute left-7 top-7 bottom-7 w-px bg-white/10" aria-hidden="true" />
              <div className="space-y-10">
                {steps.map((s, i) => (
                  <Step key={s.n} s={s} i={i} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
